import classNames from "classnames";
import SearchBar from "DreamStream/Shared/SearchBar";
import React from "react";
import { useState, useEffect } from "react";
import Card from "../../../shared/Card";

import LosPluginList from "./LosPluginsList";
import styles from "./LosTab.module.css";
import Loader from "shared/Loader";

export function LosTab({ plugins }) {
  const [sortedPlugins, setSortedPlugins] = useState([]);
  const [viewedPlugin, setViewedPlugin] = useState(null);

  useEffect(() => {
    if (plugins) {
      setSortedPlugins(plugins);
    }
  }, [plugins]);

  const onSearch = (searchText) => {
    const searchWords = searchText.trim().toLowerCase().split(/\s+/);

    const newSort =
      searchText.length > 0
        ? plugins.filter((plugin) => {
            return searchWords.every(
              (word) =>
                String(plugin.plugeeIBONumber).includes(word) ||
                String(plugin.targetIBONumber).includes(word) ||
                String(plugin.plugeeBusinessType).includes(word) ||
                String(plugin.plugeeOrganizationName)
                  .toLowerCase()
                  .includes(word) ||
                String(plugin.targetGroupName).toLowerCase().includes(word) ||
                String(plugin.targetOrganizationName)
                  .toLowerCase()
                  .includes(word)
            );
          })
        : plugins;
    setSortedPlugins(newSort);
  };

  return (
    <div className={styles.container}>
      <div className={styles.subHeader}>
        LOS Plugins is used to <strong>MOVE</strong> all IBOs in one DreamStream
        group (Plugin Org/Group) into a different DreamStream Group (Target
        Org/Group). The IBOs in the Plugee Org/Group will no longer see this
        group but instead will see the Target Org/Group.
      </div>
      <Card className={styles.cardContainer}>
        <div className={styles.header}>LOS Plugins</div>
        <SearchBar
          onInput={(searchText) => onSearch(searchText)}
          placeholderText="Search by IBO, Organization Name, or Group Name"
          searchDelay={0}
          minChar={0}
          className={styles["search-bar"]}
          btn={true}
        />

        {/* {pluginsState !== null ? ( */}
        <LosPluginList plugins={sortedPlugins} />
        {/* ) : (
          <Loader />
        )} */}
      </Card>
    </div>
  );
}
